export default "/images/crypto_environments/ethereum_audit_3.png";